import React from 'react';
import classnames from 'classnames';

import { Container, Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Image, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: { marginTop: theme.spacing(7.5) },
  container: {
    width: '90%',
    [theme.breakpoints.up('sm')]: {
      width: '50%'
    }
  },
  containerWrapperImg: { padding: 0 },
  containerWrapperText: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 4,
    borderTop: 'none',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3)
    }
  },
  img: {
    width: '100%',
    borderRadius: theme.shape.borderRadius * 4,
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px'
  },
  subtitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

interface ErrorMessageContainerProps {
  imageSrc: string
  title: string
  subtitle: string
  ctaText?: string
  ctaHrefRedirect?: string
}

export default function ErrorMessageContainer ({
  imageSrc,
  title,
  subtitle,
  ctaText,
  ctaHrefRedirect
}: ErrorMessageContainerProps) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Container className={classnames(classes.container, classes.containerWrapperImg)}>
        <Image className={classes.img} src={imageSrc} alt='' />
      </Container>
      <Container className={classnames(classes.container, classes.containerWrapperText)}>
        <Typography variant='h4'>
          <Translate content={title} />
        </Typography>
        <Translate
          className={classes.subtitle}
          component='div'
          content={subtitle}
        />
        {
          ctaText && ctaHrefRedirect && (
            <Button
              variant='contained'
              color='primary'
              href={ctaHrefRedirect}
            >
              <Translate content={ctaText} />
            </Button>
          )
        }
      </Container>
    </div>
  );
}
